import {HttpValidationErrorResponseInterface} from '@core/interfaces/http-error-response.interface';
import {HttpErrorResponse} from '@angular/common/http';

export class ResponseValidationErrorTypeGuard {
    static is(errorResponse?: HttpErrorResponse): errorResponse is HttpValidationErrorResponseInterface {
        return undefined !== errorResponse && errorResponse.hasOwnProperty('context');
    }
}
